import * as User      from '../user';
import { connect }    from 'react-redux';
import Navbar         from '../components/navbar';
import React          from 'react';
import TabPageLink    from '../components/tab_page_link';

import AddContactIcon from '../assets/icons/add_contact.svg';
import AddFileIcon    from '../assets/icons/add_file.svg';
import KioskModeIcon  from '../assets/icons/kiosk_mode.svg';


export default connect(
  (state, { businessID }) => ({
    businessID,
    isManager: User.isManager(state, businessID)
  })
)(AddPage);


function AddPage({ tabActive, businessID, isManager }) {

  return (
    <React.Fragment>
      <Navbar title="Add Contacts" backLink={`/${businessID}/contacts`}/>
      <div className="page-content add-tab">
        <div className="block list media-list">
          <ul>
            <TabPageLink
              active={tabActive === 'AddCustomer'}
              href={`/${businessID}/contacts/add/one`}
              title="Add Contact"
              icon={<AddContactIcon/>}>
              Add a single contact
            </TabPageLink>
            <TabPageLink
              href={`/${businessID}/contacts/add/kiosk`}
              className="kiosk-mode-item"
              title="Kiosk Mode"
              icon={<KioskModeIcon/>}>
              Or use Kiosk Mode when you want to hand this device to your customer
            </TabPageLink>
            {isManager && (
              <TabPageLink
                active={tabActive === 'AddFromFile'}
                href={`/${businessID}/contacts/add/file`}
                className="add-from-file-item only-desktop"
                title="Add From File"
                icon={<AddFileIcon/>}>
                Import customers from a file (CSV, Excel, etc)
              </TabPageLink>
            )}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
}
